import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from '@/config/supabase';

/**
 * ============================================================================
 * ⚠️ WARNING: DO NOT USE supabase.from().select() DIRECTLY!
 * ============================================================================
 * 
 * Supabase has a 1000 row limit that will SILENTLY TRUNCATE results.
 * 
 * ALWAYS use the centralized query client instead:
 * 
 *   import { db } from '@/lib/supabaseQuery';
 *   
 *   // Fetch all records (automatically paginated - NO 1000 LIMIT)
 *   const data = await db.fetchAll('table_name', 'column1, column2');
 *   
 *   // With filters
 *   const filtered = await db.fetchAll('table_name', '*', {
 *     filters: [{ column: 'status', operator: 'eq', value: 'active' }]
 *   });
 *   
 *   // Fetch single record
 *   const item = await db.fetchOne('table_name', '*', [
 *     { column: 'id', operator: 'eq', value: id }
 *   ]);
 *   
 *   // Count records (efficient, uses head: true)
 *   const count = await db.count('table_name');
 *   
 *   // Fetch top N (intentional limit)
 *   const recent = await db.fetchTop('table_name', '*', 10);
 * 
 * See: src/lib/supabaseQuery.ts for full API documentation
 * ============================================================================
 */
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    storageKey: 'sb-mnwkwoxlplzzytotqjcf-auth-token',
  },
});
